import {createSelector} from "@reduxjs/toolkit";
import {State} from "../../../store";
import useSelector from "../../common/hooks/useSelector";
import AuditNewState from "../types/AuditNewState";

export default function useAuditNewSelector<TSelected>(selector: (state: AuditNewState) => TSelected, equalityFn?: (left: TSelected, right: TSelected) => boolean): TSelected {
    const reselect = createSelector((state: State) => state.auditNew, selector);
    return useSelector(reselect, equalityFn);
}